import { isScientificNotation } from '@instructure/quiz-scientific-notation';
export function scientificNotation(value, _ref) {
  var message = _ref.message;
  if (!isScientificNotation(value)) {
    return message;
  }
}
export function noScientificNotation(value, _ref2) {
  var message = _ref2.message;
  if (isScientificNotation(value)) {
    return message;
  }
}